import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { TArea, TStyles } from '~/src/features/movix-new/ContentCard';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 54px;
  flex-wrap: nowrap;
`;

export const Block = styled(Row)<{ area: TArea, withoutDisplayColumn?: boolean, styles?: TStyles }>`
  padding: 8px 8px 8px 50px;
  background: ${COLORS.BgMain}0D;
  border-radius: 24px;
  align-items: center;
  grid-area: ${({ area }) => area};

  @media (max-width: ${breakPoints.desktop}) {
    column-gap: 35px;
    padding: 8px 8px 8px 20px;
  }

  @media (max-width: ${breakPoints.sDesktop}) {
    column-gap: 32px;
  }

  @media (max-width: ${breakPoints.tablet}) {
    ${({ area, withoutDisplayColumn }) => {
      if (withoutDisplayColumn) {
        return '';
      }
      return area !== 'large' && css`flex-direction: column-reverse;`;
    }};
    padding: ${({ area }) => area !== 'large' ? '8px 8px 40px 8px' : '8px 8px 0 22px'};
    justify-content: flex-end;
  }

  @media (max-width: ${breakPoints.mobile}) {
    flex-direction: column-reverse;
    padding: 8px 8px 40px 8px;
  }

  ${({ styles }) => styles}
`;

export const Title = styled.div<{ styles?: TStyles }>`
  ${FONTS.H3}
  color: ${COLORS.TextWhite};

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.H5}
  }

  @media (max-width: ${breakPoints.tablet}) {
    margin: auto 8px;
    ${FONTS.H4}
  }

  @media (max-width: ${breakPoints.mobile}) {
    width: fit-content;
  }

  ${({ styles }) => styles}
`;

export const Description = styled.div`
  ${FONTS.S};
  color: ${COLORS.TextWhite};
  max-width: 460px;

  @media (max-width: ${breakPoints.sDesktop}) {
    ${FONTS.XXS};
  }

  @media (max-width: ${breakPoints.tablet}) {
    ${FONTS.XS};
    margin: auto 8px;
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-wrap: nowrap;
  row-gap: 8px;

  @media (max-width: ${breakPoints.mobile}) {
    padding-left: 4px; 
    padding-right: 4px; 
  }
`;

export const ImageBlock = styled.div<{ area: TArea, styles?: TStyles }>`
  min-height: 136px;
  min-width: 136px;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${breakPoints.tablet}) {
    min-height: 112px;
    min-width: ${({ area }) => area === 'large' ? 263 : 112}px;
    margin-bottom: 8px;
  }

  @media (max-width: ${breakPoints.mobile}) {
    min-height: 88px;
    min-width: ${({ area }) => area === 'large' ? 160 : 88}px;
    width: ${({ area }) => area === 'large' ? '100%' : ''};
  }

  ${({ styles }) => styles}
`;

export const Image = styled.img`
  width: 100%;
`;
